module.exports = __webpack_public_path__ + "img/settings-red.1cf29a99.svg";